






























import Component, { mixins } from "vue-class-component";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import WithUserVerification from "@/mixins/WithUserVerification";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BasePage from "@/components/BasePage";
import PayeeInfoSetupView from "./components/PayeeInfoSetupView.vue";
import PayeeInfoView from "./components/PayeeInfoView.vue";

@Component({
  name: "PagePayeeInfo",
  components: { PayeeInfoView, PayeeInfoSetupView, BasePage, BaseConfirm, BaseButton },
})
export default class PagePayeeInfo extends mixins(WithAuthUser, WithUserVerification) {
  public showContractConfirm = false;

  public get showSetup() {
    return this.authUserVerificationStatus === UserVerificationStatus.UNVERIFIED;
  }

  public async created() {
    await this.userVerificationFindMyStatus();
  }

  public get creatorContractUrl(): string {
    return config.creatorContractUrl;
  }
}
